import { render, staticRenderFns } from "./NavigationText.vue?vue&type=template&id=5f59dcde&"
import script from "./NavigationText.ts?vue&type=script&lang=ts&"
export * from "./NavigationText.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationText.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports